module.exports = __webpack_public_path__ + "static/img/banner.79337f4c.png";